import { ReactNode, useEffect } from 'react';
import { CategoriesApi } from '@/shared/api/CategoriesApi.ts';
import { Category } from '@/shared/model/category.ts';
import { ModalSize, useModal } from '@fs/uikit-react';
import { ApiError } from '@/services/api';

export let refreshCategories = () => {};
export let openModal: (size: ModalSize, title: string, content: ReactNode) => void;

export const useInit = (
  setCategories: (value: Category[]) => void,
  setLoading: (value: boolean) => void,
  setError: (value: ApiError | null) => void
) => {
  openModal = useModal().openModal;

  useEffect(() => {
    refreshCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await CategoriesApi.getAll();
        setCategories(response.data as Category[]);
      } catch (err) {
        setError(err as ApiError);
        console.error('Error fetching categories:', err);
      } finally {
        setLoading(false);
      }
    };
  }, [setCategories, setLoading, setError]);
};
